import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBZMhbTwaC4CvrCQm0tyhVDGdeR_ilbh_M",
  authDomain: "bergisch-metall-partnerportal.firebaseapp.com",
  projectId: "bergisch-metall-partnerportal",
  storageBucket: "bergisch-metall-partnerportal.appspot.com",
  messagingSenderId: "623857490678",
  appId: "1:623857490678:web:ebc44ea85a78245717ead7",
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);

export const firestore = firebase.firestore();
export const storage = firebase.storage();
